module.exports = __webpack_public_path__ + "img/user-small.d9aa73e0.png";